<template>
  <div class="goods-detail-page">
    <!-- <div class="breadcrumbs c-layout">
      <span>首頁</span>
      <span class="p-16">/</span>
      <span>商品一览</span>
      <span class="p-16">/</span>
      <span>女性專區</span>
      <span class="p-16">/</span>
      <span>{{goods.ind_name}}</span>
      <span class="p-16">/</span>
      <span class="o-color">{{goods.name}}</span>
    </div> -->
    <div class="goods-detail-meta c-layout" v-loading="loading">
      <div class="tb-wrap">
        <div class="goods-main-img">
          <!-- <i class="icon"></i> -->
          <!-- Swiper -->
          <div class="back-btn show-on-pad">
            <Icon type="arrow-right" @clickevent="handleBack" />
          </div>
          <div class="swiper-container tb-wrap__top show-on-pad-flex">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="(item,index) in goods.other.photo" :key="index">
                <img class="img-responsive" :src="item" />
              </div>
            </div>
            <!-- Add Pagination -->
            <div class="swiper-pagination"></div>
          </div>

          <img class="img-responsive hide-on-pad" :src="previewImg" alt />

        </div>
        <div class="tb-wrap__bottom swiper-container hide-on-pad-flex" v-if="goods">
          <div class="swiper-wrapper">
            <div class="swiper-slide item" v-for="(item,index) in goods.other.photo" :key="index">
              <img @mousemove.prevent="mousemove(item)" class="img-responsive" :src="item" alt />
            </div>
          </div>
        </div>
      </div>
      <div class="tb-gallery">
        <div class="tips">{{goods.typename}}{{goods.ind_name}}</div>
        <div class="goods-name">{{goods.name}}</div>
        <div class="score-bar">
          <el-rate v-model="goods.star" disabled></el-rate>
          <div class="line">|</div>
          <div class>{{ goods.star }}{{ $t('goods_detail.star') }}</div>
        </div>
        <div class="tm-fcs-panel">
          <div class="price">${{ getPrice }}</div>
          <div class="promo-price">${{goods.price}}</div>
          <div class="goods-spec">{{goods.no}}</div>
        </div>
        <div class="sku-box">
          <div class="cloud-prop">
            <div class="metatit">{{ $t('goods_detail.color') }}</div>
            <div class="item-bar">
              <div
                class="item pos-center"
                v-for="(item,index) in goods.product_standard.color"
                :key="index"
                :class="{'active':select.colorIndex == index}"
              >
                <img
                  @click="selectSku(index,'color')"
                  class="img-responsive"
                  :src="item.photo"
                  alt
                />
              </div>
            </div>
          </div>
          <div class="cloud-prop">
            <div class="metatit">{{ $t('goods_detail.standard') }}</div>
            <div class="item-bar">
              <div
                class="item pos-center"
                v-for="(item,index) in goods.product_standard.standard"
                :key="index"
                :class="{'active':select.bustIndex == index}"
                @click="selectSku(index,'bust')"
              >{{item.name}}</div>
              <!-- <div
                class="item pos-center"
                v-for="(item,index) in sku.bust"
                :key="index"
                :class="{'active':select.bustIndex == index}"
                @click="selectSku(index,'bust')"
              >{{item}}</div> -->
            </div>
          </div>
          <div class="cloud-prop">
            <div class="metatit">{{ $t('goods_detail.size') }}</div>
            <div class="item-bar">
              <div
                class="item pos-center"
                v-for="(item,index) in goods.product_standard.size"
                :key="index"
                :class="{'active':select.sizeIndex == index}"
                @click="selectSku(index,'size')"
              >{{item.name}}</div>
            </div>
          </div>
        </div>
        <div class="introduce">
          <i class="straighten"></i>
          <span class="introduce-tx" @click="showWearDetail">{{ $t('goods_detail.size_intro') }}</span>
        </div>
        <div class="cloud-prop">
          <div class="metatit">{{ $t('goods_detail.qty') }}</div>
          <div class="item-bar">
            <button class="item pos-center" @click="handleDecrement">－</button>
            <div class="item pos-center clear-border">{{number}}</div>
            <button class="item pos-center" @click="handleIncrement">+</button>
          </div>
        </div>
        <button class="buy-btn bt hide-on-pad" @click="handleAddCart">{{ $t('goods_detail.add_now') }}</button>
        <div class="btn-block show-on-pad-flex">
          <div class="icon-block"><div class="service-icon"></div>{{ $t('goods_detail.service') }}</div>
          <button class="buy-btn bt" @click="handleAddCart">{{ $t('goods_detail.add_now') }}</button>
        </div>
        <div class="discount-tips">{{ $t('goods_detail.can_use_coupon') }}</div>
        <el-collapse class="cloud-collaps" style="width:100%;overflow:hidde" v-model="activeNames" v-if="goods">
          <el-collapse-item :title="$t('goods_detail.product_intro')" name="1">
            <div v-html="goods.content"></div>
            <!-- <video
              v-for="(item,index) in goods.other.movie"
              :key="index"
              :src="item"
              controls="controls"
            >您的浏览器不支持 video 标签。</video> -->
            <div v-for="(item,index) in goods.other.movie" :key="index" >
              <div v-html="item" ></div>
            </div>
            <!-- <iframe height=498 width=510 src='https://player.youku.com/embed/XNDc1MzQ2MDA2MA==' frameborder=0 allowfullscreen></iframe> -->
          </el-collapse-item>
          <el-collapse-item :title="$t('goods_detail.desc')" name="2" class="collapse-detail">
            <p>{{ $t('goods_detail.product_no') }}：{{goods.supplyNo}}</p>
            <p>{{ $t('goods_detail.supply_company') }}：{{goods.origin}}</p>
            <p>{{ $t('goods_detail.material') }}：{{goods.material}}</p>
            <!-- <p>貨號：40-90HP11-200</p> -->
          </el-collapse-item>
          <el-collapse-item :title="$t('goods_detail.wash_way')" name="3" class="collapse-wash-method">
            <div class="wish-icon">
              <i v-for="(icon,index) in goods.wash_label" :key="index+'_wash_icon'" :style="{ backgroundImage: 'url('+ icon +')' }"></i>
            </div>
            <a href class="wish-link" @click="showWashDetail">{{ $t('goods_detail.wash_way_desc') }}</a>
          </el-collapse-item>
          <el-collapse-item :title="$t('goods_detail.maintenance')" name="4" class="collapse-maintain">
            <!-- <a href>調整型內衣的正確穿法</a>
            <a href>胸罩的日常保養方式</a> -->
            <router-link v-for="(item,index) in goods.other.document" :to="{name:'guideDetail',query:{id:item.id}}" :key="'document_link_'+index">{{ item.name }}</router-link>
          </el-collapse-item>
          <el-collapse-item :title="$t('goods_detail.markup')" name="5">
            <div class="collapse-goods-list" v-for="(item,index) in goods.addlist" :key="index">
              <img class="goods-img" :src="item.photo" alt />
              <div class="goods-info">
                <p class="goods-name-256">{{item.name}}</p>
                <div class="goods-info-bottom">
                  <span>NT{{item.add_price}}</span>
                  <span>NT{{item.price}}</span>
                </div>
                <!-- <button class="add-cart-btn-256 show-on-pad" @click="handleOpenAddCartDrawer(item.id)">加入購物車</button> -->
                <button class="add-cart-btn-256" @click="handleOpenAddCartDrawer(item.id)">{{ $t('btns.add_cart') }}</button>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
        <div class="share">
          <span>{{ $t('goods_detail.share') }}:</span>
          <div class="icon-list">
            <img src="./images/012654894_03.png" alt @click="handleOpenShareBlock" />
            <img src="./images/012654894_05.png" alt />
            <img src="./images/012654894_07.png" alt @click="handleWeiboShare"/>
          </div>
        </div>
      </div>
    </div>
    <GoodsFlexible :list="goods.likelist" :title="$t('goodsFlexible.series')" sub-title="SERIES" tag="hot" />
    <GoodsFlexible :list="recommendList" :title="$t('goodsFlexible.recommend')" sub-title="RECOMMEND" tag="hot" />
    <GoodsFlexible :list="recentGoods"  :title="$t('goodsFlexible.recent')" sub-title="RECENT" tag="hot" />

    <AddCartDrawer ref="drawer"/>

    
    <div class="overlay" :class="{ active: isShowWashDetail || isShowWearDetail || isOpenShareBlock }" @click="handleCloseDetail"></div>
    <div class="detail-img-block" :class="{ active: isShowWearDetail }">
      <img :src="wearDetailPhoto">
    </div>
    <div class="detail-img-block" :class="{ active: isShowWashDetail }">
      <img :src="washDetailPhoto">
    </div>
    <div class="share-block" :class="{ active: isOpenShareBlock }">
      <div class="social-media">
        <facebook :url="shareurl" scale="3"></facebook>
        <twitter :url="shareurl" title="Check me on Github" scale="3"></twitter>
        <linkedin :url="shareurl" scale="3"></linkedin>
        <telegram :url="shareurl" scale="3"></telegram>
        <whats-app :url="shareurl" title="Hello" scale="3"></whats-app>
        <pinterest :url="shareurl" scale="3"></pinterest>
        <reddit :url="shareurl" scale="3" title="My Github"></reddit>
        <google :url="shareurl" scale="3"></google>
        <email :url="shareurl" subject="Hello" scale="3"></email>
      </div>
      <div class="share-link-string">
        <input type="text" readonly :value="shareurl" id="product-share-link">
        <div class="copy-btn" @click="handleCopyLink">{{ $t('goods_detail.copy') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import GoodsFlexible from "@/components/GoodsFlexible";
import AddCartDrawer from '@/components/AddCardDrawer/index.vue'
import { getGoodsDetail, getGoodsList, addCart } from "@/api";
import { set, get } from "@/utils/localStorage";
import Mixin from "@/utils/goodsMixin";
import { mapState } from 'vuex'
import washDetailPhoto from './images/wash-detail.jpg'
import wearDetailPhoto from './images/wear-detail.png'
import { 
  Facebook,
  Twitter,
  Linkedin,
  Pinterest,
  Reddit,
  Telegram,
  WhatsApp,
  Email,
  Google 
} from 'vue-socialmedia-share';

export default {
  mixins:[Mixin],
  data() {
    return {
      washDetailPhoto,wearDetailPhoto,
      loading: false,
      number: 1,
      data: "",
      scoreValue: 3.5,
      pageSize: 20,
      activeNames: ["1", "2", "3", "4", "5"],
      goods: {
        other: {
          photo: ''
        },
        product_standard: {
          standard: [],
          color: [],
          size: []
        }
      },
      previewImg: "",
      select: {
        colorIndex: 0,
        bustIndex: 0,
        sizeIndex: 0,
      },
      sku: {
        color: ["黑色", "白色", "蓝白色", "棕色"],
        bust: ["32", "34", "36", "38"],
        size: ["A", "B", "C", "D"],
      },
      recommendList: "",
      isShowWashDetail: false,
      isShowWearDetail: false,
      isOpenShareBlock: false,
      shareurl: 'http://test.e-dwo.com/#/goods/detail?goods_id=1',
      shareTitle: this.$t('goods_detail.share_desc')
    };
  },
  computed: {
    ...mapState(['userInfo']),
    getPrice() {
      return this.goods.price2 ? this.goods.price2 : this.goods.price1 ? this.goods.price1 : this.goods.price;
    }
  },
  created() {
    this.shareurl = location.href;
  },
  mounted() {
    this.goods_id = this.$route.query.goods_id;
    this.loading = true;
    getGoodsDetail({ goods_id: this.goods_id }).then((res) => {
      res.product.star = parseFloat(res.product.star);
      this.goods = res.product;
      this.previewImg = res.product.other.photo[0];
      this.loading = false;
      this.initSwiper();
      this.pushGoodsStore(res.product);
    });
    this.getRecommendList();
  },
  methods: {
    async handleAddCart() {
      // 如果沒登入跳到登入頁
      if(!this.userInfo) {
        this.$router.push({ name:'register', query: { type: 'login' }});
        return;
      }
      const loadingInstance = this.$loading();
      try {
        const price = this.getPrice;
        const postData = {
          store_id: this.userInfo.user.store_id,
          product_id: this.goods.id,
          color: this.goods.product_standard.color[parseInt(this.select.colorIndex)].name,
          size: this.goods.product_standard.size[parseInt(this.select.sizeIndex)].name,
          standard: this.goods.product_standard.standard[parseInt(this.select.bustIndex)].name,
          qty: this.number,
          price
        };

        await addCart(postData);

        loadingInstance.close();

        this.$message({
          message: this.$t('alert_message.add_cart_success'),
          type: "success",
        });
        this.$store.commit('SET_CART_NUMBER');
      } catch (error) {
        loadingInstance.close();
        this.$message({
          message: this.$t('alert_message.some_error'),
          type: "error",
        });
      }
    },
    handleDecrement() {
      if (this.number == 1) return;
      this.number--;
    },
    handleIncrement() {
      if (this.number == this.goods.max_order_qty) return;
      this.number++;
    },
    selectSku(index, type) {
      switch (type) {
        case "color":
          this.select.colorIndex = index;
          break;
        case "bust":
          this.select.bustIndex = index;
          break;
        case "size":
          this.select.sizeIndex = index;
          break;
      }
    },
    async getRecommendList(data) {
      getGoodsList({ recommend: this.pageSize }).then((res) => {
        this.recommendList = res.recommend;
      });
    },
    initSwiper() {
      setTimeout(() => {
        new Swiper(`.tb-wrap__top`, {
          pagination: {
            el: '.swiper-pagination',
          },
        });

        new Swiper(`.tb-wrap__bottom`, {
          slidesPerView: 4,
          spaceBetween: 16,
        });
      }, 20);
    },
    mousemove(url) {
      this.previewImg = url;
    },
    pushGoodsStore(data) {
      let currGoodsId = data.id;
      let recentGoodsArr = get("recent-goods") || [];

      if (recentGoodsArr.length == 0) {
        recentGoodsArr.push(data);
        set("recent-goods", recentGoodsArr);
      } else {
        let result = recentGoodsArr.some((item) => {
          return item.id == currGoodsId;
        });
        if (!result) {
          if (recentGoodsArr.length > 12) {
            recentGoodsArr.splice(0, 1);
          }
          recentGoodsArr.push(data);
          set("recent-goods", recentGoodsArr);
        }
      }
    },
    async handleOpenAddCartDrawer(pid) {
      // this.choosePid = pid;
      this.$refs.drawer.handleOpenAddCartDrawer(pid);
    },
    showWashDetail(e) {
      e.preventDefault();
      this.isShowWashDetail = true;
      document.body.style.overflow = 'hidden';
    },
    showWearDetail(e) {
      e.preventDefault();
      this.isShowWearDetail = true;
      document.body.style.overflow = 'hidden';
    },
    handleCloseDetail() {
      this.isShowWashDetail = false;
      this.isShowWearDetail = false;
      this.isOpenShareBlock = false;
      document.body.style.overflow = 'initial';
    },
    handleOpenShareBlock() {
      this.isOpenShareBlock = true;
      document.body.style.overflow = 'hidden';
    },
    handleCopyLink() {
      const input = document.querySelector('#product-share-link');
      input.select();
      if (document.execCommand('copy')) {
        document.execCommand('copy');
      }
    },
    handleWeiboShare() {
      const share = {
        title: this.goods.name,
        image_url: this.goods.photo,
        share_url: this.shareurl
      };
      console.log(share);
      location.replace('https://service.weibo.com/share/share.php?url=' + encodeURIComponent(share.share_url) + '&title=' + share.title + '&pic=' + share.image_url + '&searchPic=true');
    },
    handleBack() {
      this.$router.push({ name: 'goods' });
    }
  },
  components: {
    GoodsFlexible,AddCartDrawer,
    Facebook,
    Twitter,
    Linkedin,
    Pinterest,
    Reddit,
    Telegram,
    WhatsApp,
    Email,
    Google
  },
};
</script>

<style  lang='less'>
.goods-detail-page {
  padding-top: 20px;
  @media (max-width:992px) {
    // padding: 0 16px;
    padding: 0;
  }
  video {
    width: 100%;
  }
  iframe {
    width: 100%;
    height: auto;
  }
  border-top: 2px solid var(---unnamed-color-707070);

  .breadcrumbs {
    .p-16 {
      padding: 0 16px;
    }
    .o-color {
      color: var(---unnamed-color-ec4f00);
    }
    padding: 35px 0;

    font-size: 16px;
    line-height: 24px;
    letter-spacing: var(--unnamed-character-spacing-0);
    color: var(---unnamed-color-707070);
  }
  .goods-detail-meta {
    // min-height: 600px;
    display: flex;
    margin-bottom: 155px;
    @media (max-width: 992px) {
      margin-bottom: 20px;
      flex-direction: column;
      padding: 0 16px;
    }
    .tb-wrap {
      width: 540px;
      flex-shrink: 0;
      flex-shrink: 0;
      @media (max-width: 992px) {
        width: 100%;
      }
      .goods-main-img {
        position: relative;
        height: 640px;
        @media (max-width: 992px) {
          margin-right: -16px;
          margin-left: -16px;
          height: auto;
          margin-bottom: 20px;
        }
        i {
          cursor: pointer;
          position: absolute;
          top: 22px;
          right: 22px;
          width: 26px;
          height: 24px;
          background: url("./images/941@2x.png") no-repeat;
          background-size: contain;
          background-position: center center;
        }
        /deep/ .swiper-container {
          .swiper-pagination-bullet {
            opacity: 1;
            background: #A3A2AA;
            margin: 0 6px;
            width: 10px;
            height: 10px;
            &.swiper-pagination-bullet-active {
              background: #3F4149;
            }
          }
        }
        .back-btn {
          position: absolute;
          z-index: 100;
        }
      }
      .tb-wrap__bottom {
        margin-top: 16px;
        display: flex;
        height: 146px;

        .item {
          width: 119px;
          height: 146px;
          border: 1px solid var(---unnamed-color-707070);
        }
      }
    }
    .tb-gallery {
      padding-left: 30px;
      @media (max-width: 992px) {
        padding-left: 0;
      }
      .tips {
        font-weight: 400;
        line-height: 1.2rem;
        font-size: 1.2rem;
        @media (max-width: 992px) {
          margin-bottom: .6rem;
          line-height: 1.2rem;
          font-size: 1rem;
        }
      }
      .goods-name {
        padding: 5px 0;
        font-weight: 400;
        font-size: 1.5rem;
        line-height: 2rem;
        @media (max-width: 992px) {
          margin-bottom: 1.5rem;
          font-size: 1.3rem;
          line-height: 1.4rem;
        }
      }
      .score-bar {
        margin-bottom: 32px;
        display: flex;
        align-items: center;
        font-weight: 500;
        font-size: 16px;
        line-height: 24px;
        color: var(---unnamed-color-707070);
        .line {
          padding: 0 10px;
        }
        @media (max-width: 992px) {
          display: none;
        }
      }
      .tm-fcs-panel {
        display: flex;
        align-items: center;
        margin-bottom: 15px;
        .price {
          display: flex;
          margin-right: 10px;
          color: var(--unnamed-color-111111);
          font-weight: 400;
          font-size: 1.3rem;
          line-height: 1.4rem;
        }
        .goods-spec,
        .promo-price {
          // margin-top: 10px;
          font-weight: 400;
          font-size: 1.3rem;
          line-height: 1.4rem;
          text-decoration: line-through;
          color: var(--unnamed-color-A9A9A9);
        }
        .goods-spec {
          text-decoration: none;
          margin-left: auto;
          color: var(---unnamed-color-707070);
          font-size: .8rem;
        }
      }
      .sku-box {
        border-top: 1px solid #E6E6E6;
        padding-top: 1.2rem;
      }
      .cloud-prop {
        margin-bottom: 18px;
        .metatit {
          font-size: 16px;
          line-height: 24px;
          color: var(---unnamed-color-707070);
        }
        .item-bar {
          display: flex;
          margin-top: 5px;
          .item {
            cursor: pointer;
            margin-right: 20px;
            width: 35px;
            height: 35px;
            font-size: 16px;
            font-weight: 500;
            line-height: 24px;
            background: var(--unnamed-color-ffffff);
            border: 1px solid var(---unnamed-color-707070);
            color: var(---unnamed-color-707070);
          }
          .item.active {
            padding: 2px;
            // border: 1px solid var(---unnamed-color-ec4f00);
            border: 1px solid var(---unnamed-color-707070);
            color: var(---unnamed-color-ec4f00);
          }
          .clear-border {
            border: none;
          }
        }
      }
      .introduce {
        display: flex;
        margin-bottom: 12px;
        .straighten {
          width: 24px;
          height: 24px;
          background: url("./images/straighten-24px@2x.png") no-repeat;
          background-size: contain;
          background-position: center center;
        }
        .introduce-tx {
          cursor: pointer;
          margin-left: 8px;
          text-decoration: underline;
          font-weight: 500;
          font-size: 16px;
          line-height: 24px;
          color: var(---unnamed-color-707070);
        }
      }
      .buy-btn {
        cursor: pointer;
        width: 255px;
        height: 54px;
        background: var(---unnamed-color-ec4f00);
        font-weight: 500;
        font-size: 16px;
        line-height: 24px;
        color: var(--unnamed-color-ffffff);
      }
      .discount-tips {
        padding: 16px 0;
        font-weight: 500;
        font-size: 16px;
        line-height: 24px;
        color: var(---unnamed-color-707070);
      }
      .btn-block {
        position: fixed;
        width: 100%;
        left: 0;
        bottom: 0;
        padding: 3px 8px;
        background: white;
        z-index: 10;
        .icon-block {
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          color: #F1391E;
          padding: 0 16px;
        }
        .service-icon {
          width: 30px;
          height: 30px;
          background-image: url('./images/forum-24px@3x.png');
          background-size: contain;
          background-repeat: no-repeat;
        }
        .buy-btn {
          flex: 1;
          height: auto;
        }
      }
    }
    .cloud-collaps {
      // border-top: 2px solid var(--unnamed-color-70707093);
      font-size: 16px;
      line-height: 24px;

      color: var(---unnamed-color-707070);

      .el-collapse-item__header {
        font-weight: 500;
        font-size: 16px;
        line-height: 24px;
        color: var(---unnamed-color-707070);
      }
      .el-collapse-item:last-child {
        .el-collapse-item__wrap {
          border: none;
        }
      }

      // .el-collapse-item__wrap {
      //   border-bottom: 2px solid var(--unnamed-color-70707093);
      // }
      // .el-collapse-item__header {
      //   border-bottom: 2px solid var(--unnamed-color-70707093);
      // }
      .el-collapse-item__content {
        padding: 16px 0;
        span {
          white-space: break-spaces !important;
        }
      }

      .collapse-detail {
        p {
          font-size: 16px;
          color: var(---unnamed-color-707070);
          margin-bottom: 8px;
        }
      }
      .collapse-wash-method {
        .wish-link {
          margin-bottom: 16px;
          font-size: 16px;
          text-decoration: underline;
          color: var(---unnamed-color-707070);
        }
        .wish-icon {
          display: flex;
          margin: 16px 0;
          i {
            width: 36px;
            height: 36px;
            margin-right: 20px;
            background-size: contain;
            background-position: center center;
            background-repeat: no-repeat;
          }
          // i:nth-child(1) {
          //   background: url("./images/01111_03.png") no-repeat;
          //   background-size: contain;
          //   background-position: center center;
          // }
          // i:nth-child(2) {
          //   background: url("./images/01111_05.png") no-repeat;
          //   background-size: contain;
          //   background-position: center center;
          // }
          // i:nth-child(3) {
          //   background: url("./images/01111_07.png") no-repeat;
          //   background-size: contain;
          //   background-position: center center;
          // }
          // i:nth-child(4) {
          //   background: url("./images/01111_09.png") no-repeat;
          //   background-size: contain;
          //   background-position: center center;
          // }
          // i:nth-child(5) {
          //   width: 52px;
          //   background: url("./images/01111_11.png") no-repeat;
          //   background-size: contain;
          //   background-position: center center;
          // }
          // i:nth-child(6) {
          //   background: url("./images/01111_13.png") no-repeat;
          //   background-size: contain;
          //   background-position: center center;
          // }
          // i:nth-child(7) {
          //   background: url("./images/01111_15.png") no-repeat;
          //   background-size: contain;
          //   background-position: center center;
          // }
        }
      }
      .collapse-maintain {
        a {
          display: block;
          margin-bottom: 13px;
          font-size: 16px;
          text-decoration: underline;
          color: var(---unnamed-color-707070);
        }
        a:last-child {
          margin-bottom: 0;
        }
      }
      .collapse-goods-list {
        position: relative;
        display: flex;
        margin-bottom: 37px;
        .goods-img {
          flex-shrink: 0;
          width: 160px;
          height: 160px;
          margin-right: 25px;
          object-fit: contain;
          // border: 1px solid var(---unnamed-color-707070);
          @media (max-width:992px) {
            width: calc(50vw - 30px);
            height: calc(50vw - 30px);
            object-fit: cover;
            border: 1px solid #707070;
          }
        }
        .goods-info {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          font-size: 1rem;
          font-weight: lighter;
          padding-right: 145px;
          width: 100%;
          @media (max-width:992px) {
            padding: 0;
            padding-bottom: 40px;
            position: relative;
          }
          .goods-name-256 {
            /*! autoprefixer: ignore next */
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
          }
          .goods-info-bottom {
            span:nth-child(1) {
              color: var(---unnamed-color-ec4f00);
              font-weight: 500;
              margin-right: 12px;
              font-size: 1.2rem;
            }
            span:nth-child(2) {
              text-decoration: line-through;
              font-size: .8rem;
            }
          }
        }
        .add-cart-btn-256 {
          position: absolute;
          right: 0;
          bottom: 0;
          cursor: pointer;
          width: 125px;
          height: 40px;
          border: 1px solid var(--unnamed-color-111111);
          color: var(--unnamed-color-111111);
          font-size: 13px;
          font-weight: lighter;
          @media (max-width:992px) {
            width: 100%;
            height: 30px;
            // position: relative;
          }
        }
      }
    }
    .share {
      display: flex;
      align-items: center;
      margin-top: 55px;
      // margin-left: 356px;
      width: 100%;
      @media (max-width:992px) {
        margin-top: 0;
      }
      span {
        margin-right: 10px;
        margin-left: auto;

        font-size: 16px;
        line-height: 24px;
        color: var(---unnamed-color-707070);
      }
      img {
        width: 33px;
        height: 33px;
        margin-right: 16px;
      }
      img:last-child {
        margin-right: 0px;
      }
    }
  }
  .overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,.4);
    display: none;
    z-index: 900;
      &.active {
      display: block;
    }
  }
  .detail-img-block {
    padding: 25px;
    background: white;
    position: fixed;
    top: 5%;
    left: 20%;
    width: 60%;
    height: 90%;
    overflow: scroll;
    transform: translateY(-120%);
    transition: all .8s;
    z-index: 901;
    border-radius: 10px;
    @media (max-width:992px) {
      top: calc((100% - 46px)*0.1 + 46px);
      left: 5%;
      width: 90%;
      height: calc((100% - 46px)*0.8);
    }
    img {
      width: 100%;
    }
    &.active {
      transform: translateY(0%);
    }
  }
  .share-block {
    padding: 20px;
    padding-right: 0;
    background: white;
    position: fixed;
    top: -100px;
    left: 50%;
    transform: translate(-50%,-50%);
    transition: all .8s;
    z-index: 901;
    border-radius: 10px;
    // width: 40%;
    &.active {
      top: 50%;
    }
    @media (max-width: 576px) {
      min-width: 278px;
    }
    .social-media {
      display: flex;
      @media (max-width: 576px) {
        display: block;
      }
    }
    span {
      margin-right: 20px;
      margin-bottom: 20px;
      display: inline-block;
    }
    .share-link-string {
      position: relative;
      #product-share-link {
        width: calc(100% - 20px);
        padding-right: 50px;
        background: rgb(239, 239, 239);
        border-color: #ddd;
      }
      .copy-btn {
        position: absolute;
        top: 5px;
        right: 35px;
        color: #3EA6FF;
        font-weight: 400;
      }
    }
  }
}
</style>
